var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.744,
    height: 15.744,
    viewBox: "0 0 15.744 15.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.443,3.354,17.04,16.5H3.845l6.6-13.149Zm0-1.426a1.138,1.138,0,0,0-.936.686L2.787,16.008c-.515.915-.077,1.664.973,1.664H17.125c1.05,0,1.488-.749.973-1.664h0L11.379,2.614a1.138,1.138,0,0,0-.936-.686Zm.984,12.792a.984.984,0,1,1-.984-.984A.984.984,0,0,1,11.427,14.72Zm-.984-1.968a.984.984,0,0,1-.984-.984V8.816a.984.984,0,0,1,1.968,0v2.952A.984.984,0,0,1,10.443,12.752Z",
    transform: "translate(-2.57 -1.928)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error_triangle.aaf6fafd5657c26dc757fb1eedc0b323.svg";
export { ForwardRef as ReactComponent };